import { useTranslation } from "react-i18next";
import { Box, Chip } from "@mui/material";

import { colors } from "../../../theme/palette";
import typography from "../../../theme/typography";

type Props = {
  activeTab: string;
  setActiveTab: (tab: string) => void;
};

const NotificationsTabs = ({ activeTab, setActiveTab }: Props) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: "flex", gap: "8px" }}>
      {["GENERAL", "GO_ALERT"].map((tab) => (
        <Chip
          key={tab}
          label={t(`layout.notifications.${tab}`)}
          component="button"
          variant="outlined"
          clickable={tab !== "GO_ALERT"}
          disabled={tab === "GO_ALERT"}
          onClick={() => setActiveTab(tab)}
          sx={{
            border: "none",
            padding: "1px 4px",
            ...typography.body14Regular,
            color: activeTab === tab ? colors.Green100 : colors.Dark600,
            background: activeTab === tab ? colors.Green25 : "transparent",
          }}
        />
      ))}
    </Box>
  );
};

export default NotificationsTabs;
